module.exports = __webpack_public_path__ + "media/gif-moro.8fd29b68.mp4";